/**
 * Abrir un cliente en Memoria directamente en un sitio (Jorge, 20/10/2026).
 *
 * Desde «Mando», cada cliente lleva enlaces a su estrategia, sus informes y sus
 * contenidos. Memoria guarda en qué cliente y apartado está en su propio estado, y
 * se monta al cambiar de pantalla; así que el pedido se deja aquí, Memoria lo lee
 * UNA vez al montarse y lo borra. Sin dirección ni almacenamiento: si se recarga,
 * se vuelve a la Memoria de siempre.
 */
export type Donde = "estrategia" | "informes" | "contenidos" | "keywords" | "como-va";

/** De qué pantalla se viene, para el botón de volver. */
export type Desde = "mando" | "contenidos";

let pedido: { clienteId: string; donde: Donde; desde: Desde } | null = null;

export function pedirCliente(clienteId: string, donde: Donde, desde: Desde = "mando"): void {
  pedido = { clienteId, donde, desde };
}

/** Lo pedido, una sola vez. */
export function tomarPedido(): { clienteId: string; donde: Donde; desde: Desde } | null {
  const p = pedido;
  pedido = null;
  return p;
}

/**
 * Y a dónde volver: la parte de «Mando» y el cliente que estaba abierto.
 *
 * Sin esto, ir a la estrategia de un cliente era un viaje de ida: Memoria no tenía
 * forma de volver, y «Mando» se abría otra vez desde el principio (Jorge, 20/10).
 */
let vuelta: { parte: string; abierto: string | null } | null = null;

export function guardarVuelta(v: { parte: string; abierto: string | null }): void {
  vuelta = v;
}

export function tomarVuelta(): { parte: string; abierto: string | null } | null {
  const v = vuelta;
  vuelta = null;
  return v;
}
